import angular from 'angular';

import { EdgeSTackDeploymentTypeSelectorAngular } from '@/edge/components/edge-stack-deployment-type-selector/edgeStackDeploymentTypeSelector';

angular.module('portainer.edge').component('edgeStackDeploymentTypeSelector', EdgeSTackDeploymentTypeSelectorAngular);
